export const environment = {
    production: false,
    cryptedUrl: false,
    apiUrl: "https://medef.documalis.com/api",
    apiUrlList: [],
    msalConfig: {
        auth: {
            clientId: '',
            authority: ''
        }
    },
    apiConfig: {
        scopes: [],
        uri: '/'
    }
};
